import React from 'react';
import LogoPic from "../../assets/images/logo.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight} from '@fortawesome/free-solid-svg-icons'
import {withRouter} from "react-router-dom";


const Actionbar = (props) => {

    return (
        <React.Fragment>
            <header className="navbar px-2 navbar-dark bg-primary-color  bd-navbar actionbar rtl fixed-top max-w-lg">
                {
                    props.noBack !== 1 &&
                    <div className="float-right back-btn text-white" onClick={() => {props.backAddress ? window.location.replace(props.backAddress) :  window.history.back()} }>
                        <FontAwesomeIcon icon={faArrowRight}/>
                    </div>
                }

                <span className="text-center m-auto rtl">
                    <img src={LogoPic} alt="Logo" className="ml-2" width={30}/>
                    <span className="px-1 text-color-header rtl">{props.title} </span>
                </span>

            </header>
        </React.Fragment>

    );
};

export default withRouter(Actionbar);
